import { cn } from "@/shared/utils/cn";

export function RowSkeleton({ className }: { className?: string }) {
  return (
    <div role="status" className={cn("flex min-h-[82px] items-center gap-3 rounded-2xl border border-border bg-card p-3", className)}>
      <span className="sr-only">Loading...</span>
      <div aria-hidden="true" className="size-10 shrink-0 rounded-xl bg-muted motion-safe:animate-pulse" />
      <div aria-hidden="true" className="flex-1 space-y-2 motion-safe:animate-pulse">
        <div className="h-4 w-1/3 rounded bg-muted" />
        <div className="h-3 w-1/2 rounded bg-muted" />
      </div>
    </div>
  );
}
